import React from 'react';
import PropTypes from 'prop-types';
import StatisticButton from 'components/Managers/Dashboard/Views/Statistics/StatisticButton';

export default function CoachingSessions({ value }) {
  return (
    <StatisticButton
      label="Coaching"
      value={value}
        // onClick={() => setShowModal(true)}
      className="bg-secondary-100"
    />
  );
}

CoachingSessions.propTypes = {
  value: PropTypes.number,
};

CoachingSessions.defaultProps = {
  value: null,
};
